import { Button, Image } from 'antd';
import { BiMinus, BiPlus } from 'react-icons/bi';
import { MdExpandLess, MdExpandMore } from 'react-icons/md';
import SelectBox from '../../components/ui/SelectBox';
import TextBox from '../../components/ui/TextBox';
import { dateFormat } from '../../utils/utils';
import { IReportItem } from './ExpandableForm';

interface ReportRowProps {
  item: IReportItem;
  index: number;
  isChild?: boolean;
  isExpanded?: boolean;
  toggleExpand?: (id: string) => void;
}

export const ReportRow = ({ item, index, isChild = false, isExpanded, toggleExpand }: ReportRowProps) => {
  const isParent = !isChild;

  return (
    <tr
      key={item._id}
      className={`${isParent && item.children.length ? 'border border-black' : 'border-t'} ${
        isChild ? 'border border-black' : ''
      } ${index % 2 === 0 ? 'bg-meta-2' : 'bg-white'}`}
    >
      <td className="px-3 py-2 align-middle">
        {isParent && item.children.length > 0 ? (
          <button onClick={() => toggleExpand?.(item._id)} className="text-lg">
            {isExpanded ? <MdExpandLess className="text-3xl" /> : <MdExpandMore className="text-3xl" />}
          </button>
        ) : (
          isChild && <span className="text-gray-400">↳</span>
        )}
      </td>

      {/* Department */}
      <td className="px-3 py-2">
        <SelectBox
          options={[]}
          placeholder="Department"
          key={item._id}
          value={item.department}
          height={55}
          width={150}
          allowClear
        />
      </td>

      {/* Customer */}
      <td className="px-3 py-2">
        <SelectBox options={[]} placeholder="Customer" value={item.customer} height={55} width={150} allowClear />
      </td>

      {/* Metal Type */}
      <td className="px-3 py-2">
        <SelectBox options={[]} placeholder="Metal Type" value={item.metalType} height={55} width={150} allowClear />
      </td>

      {/* Jewellery Type */}
      <td className="px-3 py-2">
        <SelectBox options={[]} placeholder="Jewellery Type" value={item.jewelleryType} height={55} width={150} allowClear />
      </td>

      {/* Qty */}
      <td className="px-3 py-2">
        <TextBox key={item._id} type="number" className="h-14 w-22 text-center" placeholder="Qty" />
      </td>

      {/* Weight Out + Buttons */}
      <td className="px-3 py-2">
        <div className="flex flex-col md:flex-row justify-center items-center gap-2">
          <Button className="bg-primary h-14 w-12" disabled={!item.weightOut}>
            <BiMinus className="text-2xl" />
          </Button>
          <TextBox
            key={item._id}
            type="number"
            className="h-14 w-22 text-center"
            placeholder="Weight Out"
            defaultValue={item.weightOut}
          />
          <Button className="bg-primary h-14 w-12" disabled={!!item.weightOut}>
            <BiPlus className="text-2xl" />
          </Button>
        </div>
      </td>

      {/* Weight Out Image */}
      <td className="px-3 py-2">
        {item.weightOutCapturedImage ? (
          <Image
            src={item.weightOutCapturedImage}
            alt="weightOutCapturedImage"
            width={80}
            height={80}
            style={{ objectFit: 'cover', borderRadius: 4 }}
          />
        ) : (
          '-'
        )}
      </td>

      {/* Weight In + Buttons */}
      <td className="px-3 py-2">
        <div className="flex flex-col md:flex-row justify-center items-center gap-2">
          <Button className="bg-primary h-14 w-12" disabled={!item.weightOut}>
            <BiMinus className="text-2xl" />
          </Button>
          <TextBox
            key={item._id}
            type="number"
            className="h-14 w-22 text-center"
            placeholder="Weight In"
            defaultValue={item.weightIn}
          />
          <Button className="bg-primary h-14 w-12" disabled={!!item.weightIn}>
            <BiPlus className="text-2xl" />
          </Button>
        </div>
      </td>

      {/* Weight In Image */}
      <td className="px-3 py-2">
        {item.weightInCapturedImage ? (
          <Image
            src={item.weightInCapturedImage}
            alt="weightInCapturedImage"
            width={80}
            height={80}
            style={{ objectFit: 'cover', borderRadius: 4 }}
          />
        ) : (
          '-'
        )}
      </td>

      {/* Timestamps and Diff */}
      <td className="px-3 py-2">{item.weightOutTime ? dateFormat(item.weightOutTime) : '-'}</td>
      <td className="px-3 py-2">{item.weightInTime ? dateFormat(item.weightInTime) : '-'}</td>
      <td className="px-3 py-2 text-center">
        {item.weightIn !== null && item.weightOut !== null ? (item.weightIn - item.weightOut).toFixed(2) : '-'}
      </td>
      {/* <td className="px-3 py-2">{dateFormat(item.createdAt)}</td> */}

      {/* Actions only for parent */}
      <td className="px-3 py-2 text-right space-x-2">
        {isParent && (
          <div className="flex justify-between gap-3">
            <Button className="bg-primary h-12 w-22" disabled={item.isCompleted || !(item.weightIn && item.weightOut)}>
              Completed
            </Button>
            <Button className="bg-primary h-12 w-29" disabled={!item.isCompleted}>
              Move to Open
            </Button>
            <Button className="bg-primary h-12 w-15" disabled={false}>
              <BiPlus className="text-2xl" />
            </Button>
          </div>
        )}
      </td>
    </tr>
  );
};
